import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} viewBox="0 0 78 86" xmlns="http://www.w3.org/2000/svg" style={{
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }}><path d="M11.7 42.9a3.9 3.9 0 00-3.9 3.9v27.3a3.9 3.9 0 003.9 3.9h54.6a3.9 3.9 0 003.9-3.9V46.8a3.9 3.9 0 00-3.9-3.9H11.7zm0-7.8h54.6c6.462 0 11.7 5.238 11.7 11.7v27.3c0 6.461-5.238 11.7-11.7 11.7H11.7C5.238 85.8 0 80.561 0 74.1V46.8c0-6.462 5.238-11.7 11.7-11.7z" style={{
      fill: "#fff"
    }} /><path d="M23.4 39a3.9 3.9 0 01-7.8 0V23.4C15.6 10.477 26.076 0 39 0c12.923 0 23.4 10.477 23.4 23.4V39a3.9 3.9 0 01-7.8 0V23.4c0-8.616-6.985-15.6-15.6-15.6-8.616 0-15.6 6.984-15.6 15.6V39z" style={{
      fill: "#fff"
    }} /></svg>;
}
export default SvgComponent;